import { render, staticRenderFns } from "./m_imageAndText.vue?vue&type=template&id=6eb4267a&scoped=true"
import script from "./m_imageAndText.vue?vue&type=script&lang=js"
export * from "./m_imageAndText.vue?vue&type=script&lang=js"
import style0 from "./m_imageAndText.vue?vue&type=style&index=0&id=6eb4267a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4267a",
  null
  
)

export default component.exports